import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  getSenderInfoList, 
  getSenderInfoDetail, 
  createSenderInfo, 
  updateSenderInfo, 
  deleteSenderInfo 
} from '../../api/senderInfo';
import { message } from 'antd';

// 初始状态
const initialState = {
  senderInfoList: [],
  total: 0,
  loading: false,
  currentPage: 1,
  pageSize: 10,
  currentSenderInfo: null
};

// 异步action - 获取发件人信息列表
export const fetchSenderInfoList = createAsyncThunk(
  'senderInfo/fetchSenderInfoList',
  async ({ page, pageSize, queryParams }, { rejectWithValue }) => {
    try {
      const response = await getSenderInfoList({ page, pageSize, ...queryParams });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 异步action - 获取发件人信息详情
export const fetchSenderInfoDetail = createAsyncThunk(
  'senderInfo/fetchSenderInfoDetail',
  async (senderId, { rejectWithValue }) => {
    try {
      const response = await getSenderInfoDetail(senderId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 异步action - 创建发件人信息
export const addSenderInfo = createAsyncThunk(
  'senderInfo/addSenderInfo',
  async (senderInfoData, { rejectWithValue, dispatch }) => {
    try {
      const response = await createSenderInfo(senderInfoData);
      message.success('创建发件人信息成功');
      // 刷新列表
      dispatch(fetchSenderInfoList({ page: 1, pageSize: 10 }));
      return response.data;
    } catch (error) {
      message.error('创建发件人信息失败');
      return rejectWithValue(error.response.data);
    }
  }
);

// 异步action - 更新发件人信息
export const modifySenderInfo = createAsyncThunk(
  'senderInfo/modifySenderInfo',
  async ({ id, data }, { rejectWithValue, dispatch }) => {
    try {
      const response = await updateSenderInfo(id, data);
      message.success('更新发件人信息成功');
      // 刷新列表
      dispatch(fetchSenderInfoList({ page: 1, pageSize: 10 }));
      return response.data;
    } catch (error) {
      message.error('更新发件人信息失败');
      return rejectWithValue(error.response.data);
    }
  }
);

// 异步action - 删除发件人信息
export const removeSenderInfo = createAsyncThunk(
  'senderInfo/removeSenderInfo',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await deleteSenderInfo(id);
      message.success('删除发件人信息成功');
      // 刷新列表
      dispatch(fetchSenderInfoList({ page: 1, pageSize: 10 }));
      return id;
    } catch (error) {
      message.error('删除发件人信息失败');
      return rejectWithValue(error.response.data);
    }
  }
);

const senderInfoSlice = createSlice({
  name: 'senderInfo',
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentSenderInfo: (state, action) => {
      state.currentSenderInfo = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // 获取发件人信息列表
      .addCase(fetchSenderInfoList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSenderInfoList.fulfilled, (state, action) => {
        state.loading = false;
        state.senderInfoList = action.payload.records;
        state.total = action.payload.total;
      })
      .addCase(fetchSenderInfoList.rejected, (state) => {
        state.loading = false;
      })
      // 获取发件人信息详情
      .addCase(fetchSenderInfoDetail.fulfilled, (state, action) => {
        state.currentSenderInfo = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setCurrentSenderInfo } = senderInfoSlice.actions;

export default senderInfoSlice.reducer;
